export default __webpack_public_path__ + "static/media/im-watching-you.4d7f8034.gif";